import { NavigationContainer } from "@react-navigation/native"
import { createStackNavigator } from "@react-navigation/stack"
import React, {
  createRef,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react"
import { AppState, Platform, StyleSheet, View } from "react-native"
import { useDispatch } from "react-redux"

import Base, { Contentful, Firebase, Storage } from "./base"
import { LoadingLogo } from "./views/common"
import { subscriptionApi } from "./views/subscriptions/api"
import WebReceiptStack from "./views/web-receipt"

export const navigationRef = createRef()

const Root = createStackNavigator()
const RootNavigation = () => {
  return (
    <NavigationContainer>
      <Root.Navigator screenOptions={Base.constants.defaultNavOptions}>
        <Root.Screen
          name="main"
          component={WebReceiptStack}
          options={{ headerShown: false }}
        />
      </Root.Navigator>
    </NavigationContainer>
  )
}

export default function Navigation() {
  const [configFetched, setConfigFetched] = useState(false)
  const dispatch = useDispatch()
  const appState = useRef(AppState.currentState)

  useEffect(() => {
    fetchConfig()
  }, [fetchConfig])

  const fetchConfig = useCallback(async () => {
    await Firebase.init()
    subscriptionApi.updateBaseUrl(
      Firebase.getConfigValue("subscription_api_url"),
    )
    setConfigFetched(true)

    const config = await Contentful.getConfig()
    if (config) {
      dispatch(Storage.actions.setConfig(config))
    }
  }, [dispatch])

  if (!configFetched) {
    return (
      <View style={styles.loading}>
        <LoadingLogo />
      </View>
    )
  }

  return <RootNavigation />
}

const styles = StyleSheet.create({
  loading: { flex: 1, justifyContent: "center" },
})
